var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 5.25H10.2812C10.5713 5.25 10.8495 5.36523 11.0546 5.57035C11.2598 5.77547 11.375 6.05367 11.375 6.34375V11.5938C11.375 11.8838 11.2598 12.162 11.0546 12.3671C10.8495 12.5723 10.5713 12.6875 10.2812 12.6875H3.71875C3.42867 12.6875 3.15047 12.5723 2.94535 12.3671C2.74023 12.162 2.625 11.8838 2.625 11.5938V6.34375C2.625 6.05367 2.74023 5.77547 2.94535 5.57035C3.15047 5.36523 3.42867 5.25 3.71875 5.25H4.8125M9.1875 3.5L7 1.3125M7 1.3125L4.8125 3.5M7 1.3125V8.77734",
    stroke: "#494E58",
    strokeWidth: 1.01818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/Icon_Upload.3f133202e6cec333e21b90f6d616cdfb.svg";
export { ForwardRef as ReactComponent };